import {
  ClientReportsDetailSection,
  ClientReportsHeaderSection,
  InsufficientAccessBackground,
  StyledActivityCardBackground,
  useAccessState
} from 'modules';
import React from 'react';
import {
  Outlet,
  useParams
} from 'react-router-dom';



export type ClientReportsActivityProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const ClientReportsActivity = (props: ClientReportsActivityProps) => {
  const params = useParams();
  const access = useAccessState('ClientReport');
  if (!access.view) {
    return (
      <InsufficientAccessBackground.FC />
    );
  }

  if (params.clientReportId) {
    return (
      <Outlet />
    );
  }

  return (
    <StyledActivityCardBackground.FC>
      <ClientReportsHeaderSection.FC />
      <ClientReportsDetailSection.FC />
    </StyledActivityCardBackground.FC>
  );
};
